import { ColorSchemeScript, MantineProvider } from '@mantine/core'
import '@mantine/core/styles.css'
import '@mantine/dates/styles.css'
import '@mantine/notifications/styles.css'
import 'mantine-gantt/styles.css'
import { ModalsProvider } from '@mantine/modals'
import { Notifications } from '@mantine/notifications'
import { keepPreviousData, QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { createRouter, RouterProvider } from '@tanstack/react-router'
import { UnauthorizedError } from './hooks/useAuth'
import { useRealtimeInvalidate } from './hooks/useRealtimeInvalidate'
import { routeTree } from './routeTree.gen'
import { appTheme, cssVariablesResolver } from './theme'

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      retry: (failureCount, error) => {
        if (error instanceof UnauthorizedError) return false
        return failureCount < 1
      },
      placeholderData: keepPreviousData,
      refetchOnWindowFocus: false,
    },
  },
})

function RealtimeBridge() {
  useRealtimeInvalidate()
  return null
}

const router = createRouter({
  routeTree,
  context: { queryClient },
})

declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router
  }
}

export function App() {
  return (
    <>
      <ColorSchemeScript defaultColorScheme="auto" />
      <MantineProvider theme={appTheme} cssVariablesResolver={cssVariablesResolver} defaultColorScheme="auto">
        <Notifications position="top-right" zIndex={2000} autoClose={4000} />
        <QueryClientProvider client={queryClient}>
          <ModalsProvider>
            <RealtimeBridge />
            <RouterProvider router={router} />
          </ModalsProvider>
        </QueryClientProvider>
      </MantineProvider>
    </>
  )
}
